import React from 'react';
import type { Block } from '../types/article';
import { renderRich } from '../utils/richText';
interface ProseProps {
  blocks: Block[];
}
export function Prose({
  blocks
}: ProseProps) {
  return <div className="space-y-5" data-id="element-56" data-mp="2izlqpancdpj3">
      {blocks.map((block, index) => <BlockView key={index} block={block} data-id="element-57" data-mp="2ny6qj8yom770" data-mpi={index} />)}
    </div>;
}
function BlockView({
  block
}: {
  block: Block;
}) {
  switch (block.type) {
    case 'p':
      return <p className="text-[18px] leading-[1.7] text-neutral-700 sm:text-[19px]" data-id="element-58" data-mp="2a4p7dp9wqwhi">{renderRich(block.text)}</p>;
    case 'beat':
      return <div className="space-y-1.5" data-id="element-59" data-mp="209dqp1exvf74">
          {block.lines.map(line => <p key={line} className="text-[19px] font-medium leading-[1.45] text-ink sm:text-[21px]" data-id="element-60" data-mp="257fl2ihtf0xw">
              {renderRich(line)}
            </p>)}
        </div>;
    case 'pull':
      return <p className="border-l-2 border-brand-600 pl-4 text-[20px] font-semibold leading-snug text-brand-700 sm:text-[22px]" data-id="element-61" data-mp="1v8q2eni3hcgl">
          {renderRich(block.text)}
        </p>;
    case 'group':
      return <div data-id="element-62" data-mp="3t3hidf4r5b49">
          <h3 className="text-[18px] font-bold text-ink sm:text-[19px]" data-id="element-63" data-mp="bt9nr11mmv5o">{block.heading}</h3>
          {block.paragraphs.map(paragraph => <p key={paragraph.slice(0, 24)} className="mt-1.5 text-[18px] leading-[1.7] text-neutral-700 sm:text-[19px]" data-id="element-64" data-mp="6v87sozhzbyf">
              {renderRich(paragraph)}
            </p>)}
        </div>;
    case 'steps':
      return <ol className="space-y-8 border-l border-brand-200 pl-6" data-id="element-65" data-mp="3p01nan8bzito">
          {block.items.map((item, index) => <li key={item.label} className="relative" data-id="element-66" data-mp="3k81qv4rgz81u" data-mpi={index}>
              <span className="absolute -left-[34px] top-0 grid h-6 w-6 place-items-center rounded-full bg-brand-700 text-[12px] font-bold text-white" aria-hidden="true" data-id="element-67" data-mp="2wjijqsk5p1bc">
                {index + 1}
              </span>
              <h3 className="text-[18px] font-bold text-ink sm:text-[19px]" data-id="element-68" data-mp="3h8b3gftg40ae">
                Step {index + 1} — {item.label}
              </h3>
              <p className="mt-1 text-[18px] leading-[1.7] text-neutral-700 sm:text-[19px]" data-id="element-69" data-mp="3q14ufai98o43">{item.text}</p>
              {item.video && <video src={item.video} autoPlay loop muted playsInline className="mt-4 block w-full rounded-md border border-brand-100 bg-white object-cover" data-id="element-70" data-mp="3uyn08s0z6n7v" />}
            </li>)}
        </ol>;
    default:
      return null;
  }
}